<template>
    <div v-if="notify">
        <div id="notification-box" class="notification-box">
            <a href="#" id="notification-close" @click="closed()" title="close">x</a>

            <div class="notification-data">
                <div class="notification-title">
                    <p id="title">
                        <span id="title" style="font-size: 12px; font-weight: 600; color: black;">{{title}}</span>
                    </p>
                </div>

                <div class="notification-notice">
                    <p id="subject">{{subject}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/messaging";
export default {
    name: "PushNotificationBox",

    components: {},

    data() {
        return {
            title: "",
            subject: "",
            userimg: "",
            messaging: firebase.messaging(),
            currentMessage: "",
            notify: false,
            msg: {}
        };
    },

    methods: {
        receiveMessage() {
            try {
                this.messaging.onMessage((payload) => {
                    // debugger
                    this.currentMessage = payload;
                    // console.log(this.currentMessage);
                    /*console.log("Message received. ", payload);
                    console.log("Data received. ", payload.notification);
                    console.log("Title received. ", payload.notification.title);
                    console.log("Body received. ", payload.notification.body);*/
                    this.setNotificationBoxForm(
                        payload.notification.title,
                        payload.notification.body
                    );
                    // console.log(message)
                    this.notify = true;
                    setTimeout(() => {
                        this.notify = false;
                    }, 6000);
                    this.getNotCount(); 
                });
            } catch (e) {
                console.log(e);
            }
        },
      
        setNotificationBoxForm(title, subject) {
            this.title = title;
            this.subject = subject;
        },

        async getNotCount(){
            const params = {
                Id: this.$store.state.user.idUsuario, 
                ClaveIdioma: this.$store.state.lang, 
                Usuario: 0
            };

            await this.$http
                .post(route("NotificacionWeb/getNotificacionesWebConteo"), params)
                .then(
                response => {
                    if (response.body.code === 200) {
                        this.$store.state.not_count = response.body.Id
                    } else {
                        console.log(response.body);
                        this.notifyMessage("danger", this.$t("app.promps.error"));
                    }
                },
                error => {
                    console.error(error);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            );
        }
    },

    created() {
        this.receiveMessage();
    },

    validations: function () {
        return {};
    },

    computed: {},
};
</script>

<style>
.notification-box {
    display: flex;
    position: absolute;
    right: 5px;
    bottom: 10px;
    width: 30%;
    height: 100px;
    background-color: #fff;
    z-index: 999;
}
#notification-close {
    position: absolute;
    color: #777;
    font: 14px;
    right: 5px;
    text-decoration: none;
    text-shadow: 0 1px 0 #fff;
    top: 2px;
    z-index: 10;
    cursor: pointer;
}

.notification-data {
    margin: 0 20px;
}
.notification-data p {
    margin: 10px 0;
    color: black;
}
.notification-notice p {
    font-size: 14px;
    font-weight: 400;
    color: black;
}
.notification-title p {
    font-size: 18px;
    font-weight: bold;
    line-height: 18px;
}
.notification-time small {
    font-size: 12px;
}

.notification-wall-number small {
    font-size: 8px;
}
/*
img{
    width: 30px;
}
*/
</style>